import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import Swal from 'sweetalert2'
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { variableGlobal, Template } from './../global.enum'
import {IntranetoldService} from './../api/intranetold.service'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CambioPwComponent } from './cambio-pw/cambio-pw.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginBgStyle: any = {};
  errorMessage: string = '';
  isSubmitting: boolean = false;
  isCancelled: boolean = false;
  constructor(
    //private _api: ApiCallService,
    private _formBuilder: FormBuilder,
    private _dbService: NgxIndexedDBService,
    private _cookieService: CookieService,
    private _route: Router,
    private _api:IntranetoldService,
    private modalService: NgbModal


  ) { }
   RUT: string;
   varGlobal = variableGlobal;
   loginData: any;

  ngOnInit(): void {
    this.varGlobal = variableGlobal;

    // Prepare background style from global enum (image or color)
    const bgImage = variableGlobal.LOGIN_BG_IMAGE as unknown as string;
    const bgColor = variableGlobal.LOGIN_BG_COLOR as unknown as string;
    this.loginBgStyle = bgImage && bgImage.length > 0
      ? { backgroundImage: `url('${bgImage}')`, backgroundColor: bgColor }
      : { backgroundColor: bgColor };

    this.loginForm = this._formBuilder.group({
      RUT: ['', [Validators.required]],
      PASSWORD: ['', Validators.required]
    });


  // si la base de datos tiene datos llenar las cookies


    this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(lg => {
      var datos:any = lg;
      if (datos) {

        this.loginDatosProcesa(datos.datos);
      }


    });


  }

  async loginDatosProcesa(datos:any)
  {


    var lg:any = datos.login;
    var token = lg.TOKEN;
    var PERFIL = lg.PERFIL;

    let tokenData: any;
    try {
      tokenData = await this._api.validaToken(token);
    } catch (e) {
      // Si falla la validación del token, mostrarmos mensaje y detenemos
      this.mostrarError('No se pudo validar la sesión. Intente iniciar sesión nuevamente.');
      return;
    }
    if (tokenData && tokenData.estado) {

      var rut = this.loginForm.value.RUT;
      var password = this.loginForm.value.PASSWORD;


      if (password.toString().length > 0 && rut.toString().length > 0 && password == rut.toString().substring(0,4)) {
        this.cambioContrasena();
      }
      else {

        this._cookieService.set("token", token);

        var perfil:any = await this._api.getPerfilAll();
        var perfiles = {id:variableGlobal.DB_TABLE_GENERAL_id_perfiles, datos: perfil.objeto};


        await this._dbService.update(variableGlobal.DB_TABLE_GENERAL, perfiles).toPromise();

        var menu:any = await this._api.getMenuPadreHijo(PERFIL);

        //inicio carga menu
        var menux = {id:variableGlobal.DB_TABLE_GENERAL_id_menu, datos: menu.objeto};
        await this._dbService.update(variableGlobal.DB_TABLE_GENERAL, menux).toPromise();


        var menuTrabajado = [];
        var menuAll:any = menu;
        var padre = menuAll.objeto.padres;
        var hijos = menuAll.objeto.hijos;
        padre.forEach(element => {

          var hijoAgregado = [];
          hijos.forEach(element2 => {
            if (element._id == element2.PADRE) {
              hijoAgregado.push(element2);

            }
          });

          element.HIJOS = hijoAgregado;

          menuTrabajado.push(element);


        });

        menux = {id:variableGlobal.DB_TABLE_GENERAL_id_menu_final, datos: menuTrabajado};
        await this._dbService.update(variableGlobal.DB_TABLE_GENERAL, menux).toPromise();

        var perfilUrl = null;

        if (datos.perfil) {
          perfilUrl = datos.perfil.URL_DEFAULT;
        }

        if (!perfilUrl) {
          perfilUrl = "/inicio"
        }


        this._cookieService.set("template", Template.NORMAL);

        // this.cambioContrasena();

        window.location.href = perfilUrl;
        //this._route.navigate([perfilUrl]);
        //fin get menu
      }
    } else {
      // Token inválido: limpiar mensaje/estado
      this.mostrarError('La sesión es inválida o ha expirado. Inicie sesión nuevamente.');
    }

  }

  async login()
  {

    this.errorMessage = '';
    this.isCancelled = false;
    if (this.loginForm.invalid) {
      this.mostrarError('Ingrese RUT y contraseña.');
      return;
    }

    this.isSubmitting = true;
    let res: any;
    try {
      res = await this._api.loginV2(this.loginForm.value.RUT, this.loginForm.value.PASSWORD, "N");
    } catch (e) {
      this.isSubmitting = false;
      this.mostrarError('No se pudo conectar al servidor. Intente nuevamente.');
      return;
    }

    localStorage.setItem("RUT_LOGUEADO", this.loginForm.value.RUT);

    // Validaciones de respuesta
    const estadoOk = res?.estado === true;
    const tieneObjeto = !!res?.objeto;
    const tieneLogin = !!res?.objeto?.login;

    if (!estadoOk || !tieneObjeto || !tieneLogin) {
      this.isSubmitting = false;
      const apiMsg = res?.mensaje || '';
      // Priorizamos mensajes claros según el caso
      let msg = 'Usuario o contraseña incorrectos.';
      if (!tieneObjeto) msg = 'Usuario no encontrado.';
      if (apiMsg) msg = apiMsg;
      this.mostrarError(msg);
      return;
    }

    
    if (res && res.objeto && res.objeto.login) {
      localStorage.setItem("CARGO", res.objeto.login.CARGO || '');
      localStorage.setItem("ID_LOGUEADO", res.objeto.login._id || '');
      localStorage.setItem("PERFILJSON", JSON.stringify(res.objeto.perfil || {}));
      localStorage.setItem("LOGIN_USER", JSON.stringify(res.objeto.login || {}));
    }

    const login = { id: variableGlobal.DB_TABLE_GENERAL_id_login, datos: res.objeto };
    this._dbService.update(variableGlobal.DB_TABLE_GENERAL, login).subscribe({
      next: () => {
        if (this.isCancelled) { this.isSubmitting = false; return; }
        this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(lg => {
          if (this.isCancelled) { this.isSubmitting = false; return; }
          const datos: any = lg;
          this.loginData = lg;
          if (datos) {
            this.loginDatosProcesa(datos.datos);
          } else {
            this.isSubmitting = false;
            this.mostrarError('No se pudo guardar la sesión local.');
          }
        }, _err => {
          this.isSubmitting = false;
          this.mostrarError('No se pudo leer la sesión local.');
        });
      },
      error: _err => {
        this.isSubmitting = false;
        this.mostrarError('No se pudo guardar la sesión local.');
      }
    });

  }

  private mostrarError(msg: string) {
    this.errorMessage = msg;
    Swal.fire({
      icon: 'error',
      title: 'Error de inicio de sesión',
      text: msg,
      confirmButtonText: 'Aceptar'
    });
  }

  cancelarLogin() {
    this.isCancelled = true;
    this.isSubmitting = false;
  }

  cambioContrasena(){
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      size:"xs",
      modalDialogClass:variableGlobal.CLASS_MODAL_BG
    };
    
    const modalRef = this.modalService.open(CambioPwComponent, ngbModalOptions);
    modalRef.componentInstance.datos.RUT = this.loginData.datos.login.RUT;
    modalRef.result.then();
  }

}
